import React, {useContext, useState} from 'react'
import PropTypes from "prop-types";
import {BeatLoader} from "react-spinners";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import HeaderActionButton from "./HeaderActionButton";

import ship from 'api/shipment/ship';

import {primaryColor} from "assets/jss/main";

import {OrderContext} from "contexts/OrderContext";
import {ShippingMethods} from "../../../../../../utils/ShippingMethods";

function GivenToCustomerButton({shipment, disabled}) {

    const [loading, setLoading] = useState(false);
    const { refreshOrder } = useContext(OrderContext);

    function shipItems() {
        ship(shipment).then(() => {
            setLoading(false)
            refreshOrder();
        }).catch(() => {
                setLoading(false)
            })
    }

    function renderLoader() {
        return (
            <BeatLoader
                sizeUnit={"px"}
                size={12}
                color={primaryColor}
                loading={true}
            />
        );
    }

    function renderButton() {
        return (
            <HeaderActionButton
                onClick={() => {
                    setLoading(true)
                    shipItems();
                }}
                disabled={disabled}
            >
                { shipment.shippingMethod.shippingMethodShopName === ShippingMethods.LOCKER ?
                    <FormattedMessage id={`picking.order.shipments.header.action.givenToCustomer.locker`} />
                    :
                    <FormattedMessage id={`picking.order.shipments.header.action.givenToCustomer`} />
                }
            </HeaderActionButton>
        );
    }

    if (loading) {
        return renderLoader();
    }

    return renderButton();
}

GivenToCustomerButton.defaultProps = {
    shipment: {}
}

GivenToCustomerButton.propTypes = {
    shipment: PropTypes.object.isRequired
}

export default connect(
    state => ({
        organization: state.currentOrganization.retrieved,
    })
)(GivenToCustomerButton);
